/* eslint-disable */
const state = () => ({
  ad: null,
  adSuggestedText: null,
  attachedMedia: [],
  autoCampaignId: null,
  characterCount: 0,
  credits: null,
  communicationItem: null,
  extensionType: null,
  hasBlacklistedWords: false,
  hasEmoji: false,
  imageType: null,
  isBackup: false,
  messageId: null,
  messageType: null,
  mockUrl: null,
  rewardId: null,
  showBlacklistModal: false,
  walletTarget: null,
  updatedSmsContent: ''
})

export const actions = {
  UPDATE_AD: function ({ commit }, ad) {
    commit('SET_AD', ad)
  },

  UPDATE_AD_IMAGE_URL: function ({ commit }, adImageUrl) {
    commit('SET_AD_IMAGE_URL', adImageUrl)
  },

  UPDATE_AD_SUGGESTED_TEXT: function ({ commit }, adSuggestedText) {
    commit('SET_AD_SUGGESTED_TEXT', adSuggestedText)
  },

  UPDATE_ATTACHED_MEDIA: function ({ commit }, {attachedMedia}) {
    commit('SET_ATTACHED_MEDIA', {attachedMedia})
  },

  UPDATE_BOOLEAN_STATUS: function ({ commit }, {stateKey, status}) {
    commit('SET_BOOLEAN_STATUS', {stateKey, status})
  },

  UPDATE_COMMUNICATION_ITEMS: function ({ commit }, { extensionType, mockUrl, rewardId, walletTarget}) {
    commit('SET_COMMUNICATION_ITEMS', {extensionType, mockUrl, rewardId, walletTarget})
  },

  UPDATE_CREDITS: function ({ commit }, creditCount) {
    commit('SET_CREDITS', creditCount)
  },

  UPDATE_MESSAGE_ID_TYPE: function ({ commit }, {autoCampaignId = null, messageId, messageType}) {
    commit('SET_MESSAGE_ID_TYPE', {autoCampaignId, messageId, messageType})
  },

  UPDATE_MESSAGE_STATE: function ({ commit }, {stateKey, stateItem}) {
    commit('SET_MESSAGE_STATE', {stateKey, stateItem})
  },

  UPDATE_SMS_CONTENT: function ({ commit }, {smsContent, characterCount}) {
    commit('SET_SMS_CONTENT', {smsContent, characterCount})
  },
}

export const mutations =  {
  SET_AD: function (state, ad) {
    state.ad = ad ? {...ad} : null
  },

  SET_AD_IMAGE_URL: function (state, adImageUrl) {
    state.adImageUrl = adImageUrl
  },

  SET_AD_SUGGESTED_TEXT: function (state, suggestedText){
    state.adSuggestedText = suggestedText
  },

  SET_ATTACHED_MEDIA: function (state, {attachedMedia}) {
    state.attachedMedia = attachedMedia
  },

  SET_BOOLEAN_STATUS: function (state, {stateKey, status}) {
    state[stateKey] = status
  },

  SET_COMMUNICATION_ITEMS: function (state, {extensionType, mockUrl, rewardId, walletTarget}) {
    state.extensionType = extensionType
    state.mockUrl = mockUrl
    state.rewardId = rewardId
    state.walletTarget = walletTarget
  },

  SET_CREDITS: function (state, creditCount) {
    state.credits = creditCount
  },

  SET_MESSAGE_ID_TYPE: function (state, {autoCampaignId, messageId, messageType}) {
    if (autoCampaignId) { state.autoCampaignId = autoCampaignId }
    state.messageId = messageId
    state.messageType = messageType
  },

  SET_MESSAGE_STATE: function (state, {stateKey, stateItem}) {
    state[stateKey] = stateItem
  },

  SET_SMS_CONTENT: function (state, {smsContent, characterCount}) {
    state.updatedSmsContent = smsContent || ''
    state.characterCount = characterCount || state.characterCount
  }
}

export const getters = {
  adId: function (state) {
    return state.ad?.ad_id
  },

  adAsLink: function (state) {
    return !!state.ad && state.imageType === 'link'
  },

  adImageUrl: function (state, getters) {
    return getters.hasAd ? state?.ad?.ad_attachment?.url : null
  },

  audios: function (state) {
    return state.attachedMedia.filter(({ label }) => label === 'audio')
  },

  hasAd: function (state, getters, rootState, rootGetters) {
    return rootGetters.showBrands && !!getters.adId
  },

  isCampaign: function (state) {
    return state.messageType === 'Campaign'
  },

  mediaCredits: function (state) {
    return state.attachedMedia?.length > 0 && state.imageType === 'mms' ? 1 : 0
  },

  mms: function (state) {
    return state.attachedMedia.filter(({ label }) => label === 'mms')
  },

  mmsAsLink: function (state, getters) {
    return !!getters.mms?.length && state.imageType === 'link'
  },

  mmsType: function (state, getters) {
    return getters.mms?.length ? 'mms' : getters.audios?.length ? 'voice text' : ''
  },

  totalCredits: function (state, getters) {
    return state.credits
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
